'use client';

import { useMountEffect } from 'primereact/hooks';
import { Messages } from 'primereact/messages';
import React, { useRef } from 'react';

const Banner = () => {
	const msgs = useRef<Messages>(null);

	useMountEffect(() => {
		if (msgs.current) {
			msgs.current.clear();
			msgs.current.show({
				severity: 'info',
				sticky: true,
				content: (
					<React.Fragment>
						<img
							width={50}
							height={50}
							alt="logo"
							src={'/images/svg/flag.svg'}
						/>
						<div className="ml-5 w-full font-poppins">
							<h1 className="font-semibold text-lg">
								Did you know that employees can be admins too?
							</h1>
							<p className="text-base font-medium">
								Select an employee to{' '}
								<span className="font-bold">edit</span> and
								change their role to{' '}
								<span className="font-bold">Admin</span>.
							</p>
						</div>
					</React.Fragment>
				),
			});
		}
	});
	return <Messages ref={msgs} />;
};

export default Banner;
